import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LangProvider } from "@/context/LangContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ProcessPage from "@/pages/ProcessPage";
import ContactPage from "@/pages/ContactPage";
import AccreditationsPage from "@/pages/AccreditationsPage";
import IndustriesPage from "@/pages/IndustriesPage";
import TrainingPage from "@/pages/TrainingPage";
import InsightsPage from "@/pages/InsightsPage";
import FAQPage from "@/pages/FAQPage";
import CareersPage from "@/pages/CareersPage";
import WhyGacaPage from "@/pages/WhyGacaPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import ImpartialityPolicyPage from "@/pages/ImpartialityPolicyPage";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppLayout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/accreditations" element={<AccreditationsPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/training" element={<TrainingPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/why-gaca" element={<WhyGacaPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-certification" element={<TermsPage />} />
          <Route path="/impartiality-policy" element={<ImpartialityPolicyPage />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
